import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatDate } from 'src/shared/functions/formatDate';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';
import { Link } from 'react-router-dom';
import { MemberSnapshot } from '../models/memberGrowthResponse';

type StatisticsMemberGrowthDataGridProps = {
  members: MemberSnapshot[];
  isNewMembers: boolean;
  disableMemberProfileLink?: boolean;
};

export const StatisticsMemberGrowthDataGrid = (props: StatisticsMemberGrowthDataGridProps) => {
  const { members, isNewMembers, disableMemberProfileLink = false } = props;
  const { t } = useTranslation();
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{t('statistics:memberProgress.headers.memberNr')}</TableCell>
            <TableCell>{t('statistics:memberProgress.headers.name')}</TableCell>
            {isNewMembers ? (
              <TableCell>{t('statistics:memberProgress.headers.admDate')}</TableCell>
            ) : (
              <>
                <TableCell>{t('statistics:memberProgress.headers.resDate')}</TableCell>
                <TableCell>{t('statistics:memberProgress.headers.resCause')}</TableCell>
              </>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {members.map((member) => {
            return (
              <TableRow key={member.member_id}>
                <TableCell>
                  {disableMemberProfileLink ? member.memberNr : <Link to={`${RoutesEnum.MemberDetails}/${member.member_id}`}>{member.memberNr}</Link>}
                </TableCell>
                <TableCell>{`${member.firstName} ${member.lastName}`}</TableCell>
                {isNewMembers ? (
                  <TableCell>{formatDate(member.admDate)}</TableCell>
                ) : (
                  <>
                    <TableCell>{formatDate(member.resDate)}</TableCell>
                    <TableCell>{member.resCause}</TableCell>
                  </>
                )}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
